import { z } from 'zod';
/** Collapses surrounding whitespace and rejects strings that are only spaces. */
export const trimmedString = (min, max) => z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().min(min).max(max));
export const optionalTrimmedString = (max) => z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().max(max))
    .optional();
/** CUID2 identifiers, as produced by Prisma's `@default(cuid(2))`. */
export const idSchema = z.string().regex(/^[a-z0-9]{20,32}$/, 'Identificador inválido');
/** Opaque public tokens: base64url, generated from 32 random bytes. */
export const publicTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{32,128}$/, 'Token inválido');
export const emailSchema = z
    .string()
    .transform((value) => value.trim().toLowerCase())
    .pipe(z.email().max(254));
/** Stable machine name for a field inside a form version. */
export const fieldKeySchema = z
    .string()
    .regex(/^[a-z0-9][a-z0-9_]{0,62}$/, 'Los nombres usan minúsculas, números y guiones bajos');
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
/** ISO-8601 date-time accepted from clients and normalised to a Date. */
export const isoDateTimeSchema = z.iso.datetime({ offset: true }).or(z.iso.datetime());
/** Calendar date without a time component, e.g. 2026-09-16. */
export const isoDateSchema = z.iso.date();
//# sourceMappingURL=common.js.map